
import { Component, Vue, Prop } from 'vue-property-decorator';
import { Action } from 'vuex-class';
import { checkRole } from '@/modules/authentication/helpers/checkRole';
import { Roles } from '@/modules/authentication/models/rolesEnum';
import { RequestStatusEnum } from '@/modules/analysis/models/requestStatusEnum';
import { AnalysisRequest, FactAnalysisRequest } from '@/modules/analysis/models/analysisRequest';
import * as AnalysisRequestService from '@/modules/analysis/services/analysisRequestService';

@Component({
  components: {}
})
export default class AboutFact extends Vue {
  @Prop()
  protected facts?: FactAnalysisRequest[];
  @Prop({ required: true })
  protected analysisId?: string;
  @Action('analysis/readAnalysisRequest')
  protected readAnalysisRequest!: (idParam: string) => Promise<AnalysisRequest>;
  @Prop({ required: true })
  protected reloadChatMessages!: () => Promise<void>;
  protected RequestStatusEnum = RequestStatusEnum;
  protected loadingButtons = { takeCharge: false, validate: false, requestValidation: false };
  protected requestError = false;
  protected requestErrorSamplesStatus = false;
  // LABORATORYNAME
  protected laboratoryNames = [
    {
      text: 'DEMBOX 1',
      value: 'DEMBOX 1'
    },
    {
      text: 'DEMBOX 2',
      value: 'DEMBOX 2'
    },
    {
      text: 'DEMBOX 3',
      value: 'DEMBOX 3'
    },
    {
      text: 'DEMBOX 4',
      value: 'DEMBOX 4'
    },
    {
      text: 'DEMBOX 5',
      value: 'DEMBOX 5'
    },
    {
      text: 'In Situ',
      value: 'In Situ'
    }
  ];
  protected laboratoryName = '';

  protected generatePictogramConfig(fact: FactAnalysisRequest): { color: string; icon: string } {
    if (fact.status == RequestStatusEnum.OPENED) {
      return { color: 'warning', icon: 'mdi-plus' };
    } else if (fact.status == RequestStatusEnum.IN_PROGRESS) {
      return { color: 'info', icon: 'mdi-cached' };
    } else if (fact.status == RequestStatusEnum.AWAITING_VALIDATION) {
      return { color: 'brown', icon: 'mdi-timer-sand' };
    } else if (fact.status == RequestStatusEnum.FINISHED) {
      return { color: 'success', icon: 'mdi-check' };
    } else if (fact.status == RequestStatusEnum.ARCHIVED) {
      return { color: 'purple lighten-2', icon: 'mdi-archive-outline' };
    }
    return { color: 'warning', icon: 'mdi-help-circle-outline' };
  }

  protected getFactFullMessage(fact: FactAnalysisRequest): string {
    let eventDate = 'N/A';
    if (this.$options.filters) {
      eventDate = this.$options.filters.dateFormat(new Date(fact.createdAt), 'DD/MM/YY HH:mm');
    }
    const eventActor = `${fact.actor.givenName} ${fact.actor.familyName}`;
    const eventStatus = this.$i18n.t(`common.genericStatuses.${fact.status}`).toString();
    const params = { eventDate, eventActor, eventStatus };
    const msg = this.$i18n.t('analysis.AboutFact.statusChange', params).toString();

    return msg;
  }

  protected updateStatus(status: RequestStatusEnum): void {
    if (status === RequestStatusEnum.IN_PROGRESS) {
      this.loadingButtons.takeCharge = true;
    } else if (status === RequestStatusEnum.AWAITING_VALIDATION) {
      this.loadingButtons.requestValidation = true;
    } else if (status === RequestStatusEnum.FINISHED) {
      this.loadingButtons.validate = true;
    }
    this.requestError = false;
    const statusBody = { status };
    AnalysisRequestService.updateStatus(this.analysisId as string, statusBody)
      .then(() =>
        this.readAnalysisRequest(this.analysisId as string)
          .then((request) => {
            this.$emit('change', request);
            this.reloadChatMessages();
          })
          .catch((e) => {
            if (e.status === 404) {
              this.$router.push({ name: '404' });
            }
          })
      )
      .catch((e) => {
        if (e.response.status === 412) {
          this.requestErrorSamplesStatus = true;
        } else {
          this.requestError = true;
        }
      })
      .finally(() => {
        this.loadingButtons.takeCharge = false;
        this.loadingButtons.requestValidation = false;
        this.loadingButtons.validate = false;
      });
  }

  protected isAvailableAction(targetStatus: RequestStatusEnum): boolean {
    if (targetStatus === RequestStatusEnum.IN_PROGRESS && this.currentStatus === RequestStatusEnum.OPENED) {
      return true;
    } else if (
      targetStatus === RequestStatusEnum.AWAITING_VALIDATION &&
      this.currentStatus === RequestStatusEnum.IN_PROGRESS
    ) {
      return true;
    } else if (
      targetStatus === RequestStatusEnum.FINISHED &&
      this.currentStatus === RequestStatusEnum.AWAITING_VALIDATION
    ) {
      return true;
    }
    return false;
  }

  protected takeCharge(): void {
    const isValid = (this.$refs.form as HTMLFormElement).validate();
    if (isValid) {
      AnalysisRequestService.updateLaboratoryName(this.analysisId as string, this.laboratoryName)
        .then(() => this.updateStatus(RequestStatusEnum.IN_PROGRESS))
        .catch(() => (this.requestError = true));
    }
  }

  protected get isSamplesStateUpdateAuthorized(): boolean {
    return checkRole(Roles.samples_update_state);
  }

  protected get isRequestUpdateStateManagerAuthorized(): boolean {
    return checkRole(Roles.requests_update_state_manager);
  }

  protected get currentStatus(): RequestStatusEnum | null {
    if (this.facts) {
      return this.facts[0].status;
    }
    return null;
  }
}
